import { Grid } from '@veracity/vui'
import { Link } from 'react-router-dom'

import { ProjectInfoCard } from '@/components'
import { ProjectSimple } from '@/interfaces'

interface Props {
  projects?: ProjectSimple[]
}

export const ProjectsListCollectionGrid = ({ projects = [] }: Props) => (
  <Grid w="100%" gap={3} gridTemplateColumns={{ xl: 4, lg: 3, md: 2, sm: 1 }}>
    {projects?.map(project => (
      <Link
        key={project.id}
        to={`/projects/${project.id}`}
        className="text-decoration-none">
        <ProjectInfoCard project={project} />
      </Link>
    ))}
  </Grid>
)
